var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-headers" },
    [
      _c(
        "div",
        {
          staticClass: "table-header-cell record-id-header",
          style: {
            width: _vm.getColumnWidth("record-id") + "px",
            minWidth: _vm.getColumnWidth("record-id") + "px",
          },
        },
        [
          _c("a-checkbox", {
            attrs: { checked: _vm.isAllSelected },
            on: {
              change: function ($event) {
                return _vm.$emit("toggle-select-all", $event.target.checked)
              },
            },
          }),
          _vm._v(" "),
          _vm.canShowPermissionSettings
            ? _c(
                "a-popover",
                { attrs: { trigger: "click", placement: "bottomLeft" } },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      { staticClass: "action-list table-actions-menu" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "action-item",
                            on: { click: _vm.goToPermissionSettings },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("admin_panel_settings"),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("tables.privacySettings"))),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "i",
                    {
                      staticClass: "material-icons table-actions-icon",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [_vm._v("more_vert")]
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-tooltip",
            { attrs: { title: _vm.createdAtSortTooltip, placement: "bottom" } },
            [
              _c(
                "i",
                {
                  staticClass: "material-icons created-at-sort-icon",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.toggleCreatedAtSort.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.isCreatedAtSortDesc
                          ? "arrow_downward"
                          : "arrow_upward"
                      ) +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "resize-handle",
            on: {
              mousedown: function ($event) {
                return _vm.startResize($event, "record-id")
              },
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "draggable",
        {
          staticClass: "drag-context-wrapper",
          attrs: { list: _vm.$_.cloneDeep(_vm.visibleFields) },
          on: { end: _vm.onDragEnd },
        },
        _vm._l(_vm.visibleFields, function (field) {
          return _c(
            "div",
            {
              key: field._id,
              staticClass: "table-header-cell",
              class: {
                selected: _vm.selectedField === field,
                identifier: field.isIdentifierField,
              },
              style: {
                width: _vm.getColumnWidth(field._id) + "px",
                minWidth: _vm.getColumnWidth(field._id) + "px",
              },
              on: {
                click: function ($event) {
                  return _vm.selectField(field)
                },
              },
            },
            [
              _c(
                "a-popover",
                { attrs: { trigger: "click", placement: "bottomLeft" } },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      { staticClass: "action-list field-actions-menu" },
                      [
                        _c(
                          "PermissionController",
                          { attrs: { permissions: ["table.update"] } },
                          [
                            !_vm.moduleMode
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "action-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAction(
                                          "editField",
                                          field
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("edit"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("tables.editField"))
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.moduleMode ? _c("a-divider") : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "action-group" },
                          [
                            _c("div", { staticClass: "group-name" }, [
                              _vm._v(_vm._s(_vm.$t("tables.sort"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "action-item",
                                class: {
                                  disabled:
                                    field.valueType === "array" ||
                                    (_vm.isSortActive(field._id) &&
                                      _vm.currentSort.direction === "asc"),
                                },
                                on: {
                                  click: function ($event) {
                                    field.valueType !== "array" &&
                                      !(
                                        _vm.isSortActive(field._id) &&
                                        _vm.currentSort.direction === "asc"
                                      ) &&
                                      _vm.handleAction("sortAscending", field)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("arrow_upward"),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("tables.sortAscending"))
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "action-item",
                                class: {
                                  disabled:
                                    field.valueType === "array" ||
                                    (_vm.isSortActive(field._id) &&
                                      _vm.currentSort.direction === "desc"),
                                },
                                on: {
                                  click: function ($event) {
                                    field.valueType !== "array" &&
                                      !(
                                        _vm.isSortActive(field._id) &&
                                        _vm.currentSort.direction === "desc"
                                      ) &&
                                      _vm.handleAction("sortDescending", field)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("arrow_downward"),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("tables.sortDescending"))
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "action-item",
                                class: {
                                  disabled:
                                    field.valueType === "array" ||
                                    !_vm.isSortActive(field._id),
                                },
                                on: {
                                  click: function ($event) {
                                    field.valueType !== "array" &&
                                      _vm.isSortActive(field._id) &&
                                      _vm.handleAction("clearSort", field)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("clear"),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("tables.clearSort"))),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "PermissionController",
                              { attrs: { permissions: ["table.update"] } },
                              [
                                !field.isIdentifierField &&
                                _vm.isValidForIdentifier(field)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "action-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAction(
                                              "makeIdentifier",
                                              field
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("check_circle")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "tables.markAsIdentifierField"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "PermissionController",
                              { attrs: { permissions: ["table.update"] } },
                              [
                                field.fieldType === "ai"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "action-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAction(
                                              "runAI",
                                              field
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("auto_awesome")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("tables.runAI"))
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("a-divider"),
                        _vm._v(" "),
                        _c(
                          "PermissionController",
                          {
                            attrs: {
                              permissions: ["table.update"],
                              controller: "every",
                            },
                          },
                          [
                            false
                              ? _c(
                                  "div",
                                  { staticClass: "action-group" },
                                  [
                                    _c("div", { staticClass: "group-name" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("tables.createField"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "PermissionController",
                                      {
                                        attrs: {
                                          permissions: ["table.update"],
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "action-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAction(
                                                  "insertBefore",
                                                  field
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("add")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("tables.insertBefore")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "PermissionController",
                                      {
                                        attrs: {
                                          permissions: ["table.update"],
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "action-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAction(
                                                  "insertAfter",
                                                  field
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("add")]
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("tables.insertAfter")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            false ? _c("a-divider") : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "PermissionController",
                          {
                            attrs: {
                              permissions: [
                                "automation.get",
                                "automation.create",
                              ],
                              controller: "every",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "action-group" },
                              [
                                _c("div", { staticClass: "group-name" }, [
                                  _vm._v(_vm._s(_vm.$t("ticimax.automation"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "PermissionController",
                                  {
                                    attrs: { permissions: ["automation.get"] },
                                  },
                                  [
                                    field.fieldType === "automation-button"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "action-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleAction(
                                                  "gotoAutomation",
                                                  field
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("AutomationIcon", {
                                              tag: "component",
                                              staticClass: "myIcon",
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "tables.goToRelatedAuto"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "PermissionController",
                                  {
                                    attrs: {
                                      permissions: ["automation.create"],
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "action-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAction(
                                              "createAutomation",
                                              field
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("settings_suggest")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("ticimax.createAutomation")
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("a-divider"),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "PermissionController",
                          {
                            attrs: {
                              permissions: ["table.update"],
                              controller: "every",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "action-group" },
                              [
                                _c("div", { staticClass: "group-name" }, [
                                  _vm._v(_vm._s(_vm.$t("tables.permission"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "PermissionController",
                                  { attrs: { permissions: ["table.update"] } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "action-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAction(
                                              "lockField",
                                              field
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("lock")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("tables.lockField"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "PermissionController",
                                  { attrs: { permissions: ["table.update"] } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "action-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleAction(
                                              "hideField",
                                              field
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("visibility_off")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("tables.hideField"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("a-divider"),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "PermissionController",
                          { attrs: { permissions: ["table.update"] } },
                          [
                            !_vm.moduleMode
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "action-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAction(
                                          "deleteField",
                                          field
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("delete"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("tables.deleteField"))
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "table-header-cell-content" },
                    [
                      _c("FieldIcon", {
                        staticClass: "mr-2",
                        attrs: {
                          type: field.fieldType,
                          "default-icon": field.icon,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "field-name" }, [
                        _vm._v(_vm._s(field.name)),
                      ]),
                      _vm._v(" "),
                      _vm.isSortActive(field._id)
                        ? _c(
                            "i",
                            {
                              staticClass:
                                "material-icons sort-icon table-icon-max-width",
                              class: {
                                "sort-active": _vm.isSortActive(field._id),
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.currentSort.direction === "asc"
                                      ? "arrow_upward"
                                      : "arrow_downward"
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "resize-handle",
                on: {
                  mousedown: function ($event) {
                    return _vm.startResize($event, field._id)
                  },
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("PermissionController", { attrs: { permissions: ["table.update"] } }, [
        !_vm.moduleMode
          ? _c(
              "div",
              { staticClass: "table-header-cell add-field-cell" },
              [
                _c(
                  "a-popover",
                  {
                    attrs: {
                      trigger: "click",
                      placement: "bottomRight",
                      overlayClassName: "zero-padding",
                    },
                    model: {
                      value: _vm.isAddFieldPopoverVisible,
                      callback: function ($$v) {
                        _vm.isAddFieldPopoverVisible = $$v
                      },
                      expression: "isAddFieldPopoverVisible",
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "content" },
                      [
                        _c("FieldSelector", {
                          on: {
                            "field-selected": _vm.openFieldCreator,
                            close: function ($event) {
                              _vm.addFieldPopoverVisible = false
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("+ " + _vm._s(_vm.$t("calendar.addField"))),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isFieldCreatorVisible
        ? _c(
            "Modal2",
            {
              attrs: {
                title:
                  _vm.fieldCreatorMode === "create"
                    ? _vm.$t("tables.createNewField")
                    : _vm.$t("tables.editField"),
                showFooter: false,
                className: "field-creator-modal keydown-prevent-modal",
                xlarge: "",
              },
              on: { cancel: _vm.closeFieldCreator },
            },
            [
              _c("FieldCreator", {
                attrs: {
                  defaultFieldType: _vm.selectedFieldType,
                  "table-id": _vm.table._id,
                  mode: _vm.fieldCreatorMode,
                  field: _vm.selectedField,
                },
                on: {
                  "field-created-success": _vm.onFieldCreated,
                  "field-updated-success": _vm.onFieldUpdated,
                  cancel: _vm.closeFieldCreator,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }